<div class="dialog dialog-send-config">
  <div class="dialog__header">
    <h3 class="dialog__title">{{ "ShortcutMenu.SendConfig" | translate }}</h3>
    <svg-icon src="assets/images/icons/x.svg" class="dialog__close" (click)="closeDialog()"></svg-icon>
  </div>

  <ng-template #step1>
    <div
      class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
    >
      <div class="dialog__inner">
        <h3 class="dialog__sub-heading">{{ "SendConfig.Title" | translate }}</h3>
        <p class="no-margin" style="margin: 0">{{ "SendConfig.Text" | translate }}</p>
      </div>

      <div class="dialog-send-config__rows">
        <div class="dialog-send-config__row">
          @for (person of persons; track $index; let i = $index) {
            <div class="dialog-send-config__row-item">
              <div class="row">
                <div class="col-6">
                  <label for="" class="form-label">{{ "Global.FullName" | translate }}</label>
                  <div class="input__wrapper">
                    <input type="text" class="input" placeholder="" [(ngModel)]="person.name" required />
                  </div>
                </div>
                <div class="col-6">
                  <label for="" class="form-label">{{ "Global.Email" | translate }}</label>
                  <div class="input__wrapper">
                    <input
                      type="email"
                      class="input"
                      placeholder=""
                      [(ngModel)]="person.email"
                      email
                      required
                      (input)="verify(i, $event)"
                      (paste)="paste(i, $event)"
                    />
                  </div>
                </div>
              </div>
              <svg-icon
                src="assets/images/icons/x.svg"
                class="dialog-send-config__remove"
                (click)="removeRow(i)"
              ></svg-icon>
            </div>
          }
        </div>
        <div class="dialog-send-config__add" (click)="addRow()">
          <svg-icon src="assets/images/icons/+.svg"></svg-icon>
        </div>
      </div>
    </div>
  </ng-template>

  <selfservice-wizard
    [steps]="[step1]"
    [getCommand]="buildCommand"
    [bus]="bus"
    [canContinue]="allValid"
    successMessage="SendConfig.SuccessText"
  />
</div>
